// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HTt9","type":"styles_type__1ace1","choices":"styles_choices__1Ta-t"};